import React from "react";
import g from "../utils/globals";
import "../../css/components/BackgroundImage.scss";

const BackgroundImage = props => {
  const src = !(props.attrs.src.indexOf("https") > -1) ? g.videoContent + props.attrs.src : props.attrs.src;
  return <div className={`background-img-component ${props.attrs.class}`} style={{ background: `url(${src})` }} />;
};

export default BackgroundImage;
